import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { navigate } from '@reach/router';
import ILocalAGGrid, {
  getDefaultColDef,
  getActionsColumn,
  openAgGridContextMenu,
  actionMenuItem,
} from '../../grid/iLocalAGGrid';
import USER_ROLES from '../../common/userroles';
import {
  createAccountResourceDatasource,
  syncGridPageSize,
} from './accountResourceGridUtils';

const getGroupTypeId = () => {
  const groupType = sessionStorage.getItem('groupType');
  if ([undefined, 'undefined', null, 'null', ''].includes(groupType)) {
    return null;
  }
  return groupType;
};

const UserSortObj = {
  name: { tableName: 'users', sortColumn: 'name' },
  username: { tableName: 'users', sortColumn: 'username' },
  email: { tableName: 'contacts', sortColumn: 'email' },
};

const resolveUserEditPermission = () => {
  try {
    const permissionUser = sessionStorage.getItem('permissionUser');
    if (permissionUser === USER_ROLES.SUPERADMIN) {
      return true;
    }
    const permissions = JSON.parse(
      sessionStorage.getItem('permissions') || '[]'
    );
    const manageUsers = permissions.filter(
      (item) => item.permission_entity_type === 'Manage Users'
    );
    return manageUsers.some(
      (x) => x.name && x.name.trim() === 'Modify' && x.is_allowed === 1
    );
  } catch (e) {
    return false;
  }
};

class AccountUsersDialog extends React.Component {
  constructor(props) {
    super(props);
    this.filterObj = {
      searchtext: '',
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'created_on',
      accountId: props.accountId,
      groupTypeId: getGroupTypeId(),
    };
    this.state = {
      useredit: resolveUserEditPermission(),
    };
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createAccountResourceDatasource({
      filterObj: this.filterObj,
      sortMap: UserSortObj,
      endpoint: 'accounts/users/by/account',
      getAccountId: () => this.props.accountId,
      getExtraBody: () => ({ groupTypeId: getGroupTypeId() }),
    });
    if (typeof params.api.setServerSideDatasource === 'function') {
      params.api.setServerSideDatasource(datasource);
    }
  };

  onPaginationChanged = (params) => {
    syncGridPageSize(params, this.filterObj);
  };

  openRowActionsMenu = (event, params, menuHelpers) => {
    const items = this.getContextMenuItems(params);
    if (menuHelpers && typeof menuHelpers.openMenu === 'function') {
      menuHelpers.openMenu(items);
      return;
    }
    openAgGridContextMenu(
      params,
      (menuHelpers && menuHelpers.positionEvent) || event
    );
  };

  getContextMenuItems = (params) => {
    const colId =
      params &&
      params.column &&
      (params.column.getColId ? params.column.getColId() : params.column.colId);
    if (colId !== 'actions') return [];
    const row = params.node && params.node.data;
    if (!row || !this.state.useredit) return [];
    const { t } = this.props;
    return [
      actionMenuItem({
        name: t('Users.EditActions'),
        icon: 'edit',
        action: () => this.handleEditUser(row),
      }),
    ];
  };

  handleEditUser = (selectedObject) => {
    if (!selectedObject || !selectedObject.id || !this.props.accountId) {
      return;
    }
    navigate(
      `/home/manage/users/0?editUserId=${encodeURIComponent(
        selectedObject.id
      )}&accountId=${encodeURIComponent(this.props.accountId)}`
    );
  };

  render() {
    const { t } = this.props;
    const { useredit } = this.state;
    const columnDefs = [
      { field: 'name', headerName: t('Home.StartConsultPopup.Name') },
      { field: 'username', headerName: t('Users.UserName') },
      {
        field: 'parent_account',
        headerName: t('Users.AssociatedAccount'),
        filter: false,
        sortable: false,
        valueGetter: (params) =>
          (params.data &&
            params.data.parentAccount &&
            params.data.parentAccount.name) ||
          '',
      },
      {
        field: 'email',
        headerName: t('Users.Email'),
        valueGetter: (params) =>
          (params.data && params.data.contact && params.data.contact.email) ||
          (params.data && params.data.email) ||
          '',
      },
    ];
    if (useredit) {
      columnDefs.push(
        getActionsColumn({
          headerName: t('Users.Actions'),
          onActionsClick: (event, params, menuHelpers) =>
            this.openRowActionsMenu(event, params, menuHelpers),
        })
      );
    }

    return (
      <ILocalAGGrid
        columnDefs={columnDefs}
        defaultColDef={getDefaultColDef()}
        rowModelType='serverSide'
        cacheBlockSize={this.filterObj.pageSize || 10}
        paginationPageSize={this.filterObj.pageSize || 10}
        paginationPageSizeSelector={[10, 20, 25]}
        rowHeight={45}
        getRowId={(params) => params.data && params.data.id}
        onGridReady={this.onGridReady}
        onPaginationChanged={this.onPaginationChanged}
        getContextMenuItems={this.getContextMenuItems}
        overlayNoRowsMessage={t('Users.NoDataFound')}
      />
    );
  }
}

AccountUsersDialog.propTypes = {
  accountId: PropTypes.string,
};

export default withTranslation()(AccountUsersDialog);



// WEBPACK FOOTER //
// ./src/components/account-list/related/AccountUsersDialog.js